import Sketchfab from '@sketchfab/viewer-api'

let api

const init = function (elementId) {
  const iframe = document.getElementById(elementId)
  const version = '1.8.2'
  return new Sketchfab(version, iframe)
}

const supportsWebgl = function () {
  let canvas, gl;
  canvas = document.createElement('canvas');
  gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
  console.log('gl', gl)

  var debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
  var vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
  var renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);

  return gl && gl instanceof WebGLRenderingContext;
};

const loadScene = function (sceneId, playerSettings) {
  return new Promise((resolve, reject) => {
    // if (!supportsWebgl()) {
    //   reject();
    // }

    let client = init('player__iframe')

    client.init(sceneId, {
      success: function onSuccess (theApi) {
        console.log('Client success')
        window.api = api = theApi
        api.load()
        api.start()
        api.addEventListener('viewerready', function () {
          console.log('Viewer ready')
          resolve(api)
        })
      },
      error: function (error) {
        reject(error)
      },
      ...playerSettings
      // annotation: playerSettings.annotation,
      // annotations_visible: playerSettings.annotations_visible,
      // orbit_constraint_pitch_down: playerSettings.orbit_constraint_pitch_down,
      // orbit_constraint_pitch_up: playerSettings.orbit_constraint_pitch_up,
      // orbit_constraint_yaw_left: playerSettings.orbit_constraint_yaw_left,
      // orbit_constraint_yaw_right: playerSettings.orbit_constraint_yaw_right,
      // orbit_constraint_zoom_in: playerSettings.orbit_constraint_zoom_in,
      // orbit_constraint_zoom_out: playerSettings.orbit_constraint_zoom_out,
      // orbit_constraint_pan: playerSettings.orbit_constraint_pan
    })
  })

}

const getApi = function () {
  return api
}

export default {getApi, init, loadScene}
